(() => {
  // Sort rendered links as well, including titles with leading whitespace.
  const collator = new Intl.Collator(document.documentElement.lang || 'en', {
    sensitivity: 'base', numeric: true
  });
  const title = node => {
    const label = node.matches('a') ? node : node.querySelector('a, summary');
    return (label ? label.textContent : node.textContent)
      .normalize('NFKC').replace(/\s+/g, ' ').trim();
  };
  const sortContainer = (container, selector) => {
    const items = [...container.children].filter(node => node.matches(selector));
    const sorted = [...items].sort((a, b) => collator.compare(title(a), title(b)));
    if (items.every((item, index) => item === sorted[index])) return;
    const slots = items.map(item => {
      const slot = document.createComment('menu-item');
      item.replaceWith(slot);
      return slot;
    });
    slots.forEach((slot, index) => slot.replaceWith(sorted[index]));
  };
  const sortMenus = () => {
    document.querySelectorAll('.mh-mattress-menu__links').forEach(node => sortContainer(node, 'a'));
    document.querySelectorAll('ul.nav-desktop__tier-2, ul.nav-desktop__tier-3, #mobile_menu ul').forEach(node => sortContainer(node, 'li'));
    document.querySelectorAll('.mh-wide-menu').forEach(node => sortContainer(node, '.mh-wide-menu__group'));
    document.querySelectorAll('.mh-wide-menu__group ul').forEach(node => sortContainer(node, 'li'));
  };
  // Explicit row layout: read each row from left to right, then move down.
  if (!document.getElementById('mh-alphabetical-menu-layout')) {
    const style = document.createElement('style');
    style.id = 'mh-alphabetical-menu-layout';
    style.textContent = `
      .mh-mattress-menu .mh-mattress-menu__links {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        grid-template-rows: none !important;
        grid-auto-flow: row !important;
        columns: auto !important;
        gap: 12px 24px;
      }
      .mh-mattress-menu .mh-mattress-menu__links > a {
        order: 0 !important;
        grid-area: auto !important;
      }
      @media (max-width: 798px) {
        .mh-mattress-menu .mh-mattress-menu__links {
          grid-template-columns: 1fr !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortMenus, { once: true });
  } else {
    sortMenus();
  }
  document.addEventListener('shopify:section:load', sortMenus);
  document.addEventListener('toggle', event => {
    if (event.target.matches('details[open]')) sortMenus();
  }, true);
  if (customElements.get('mh-mattress-menu')) return;
  customElements.define('mh-mattress-menu', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      const tabs = [...this.querySelectorAll('[data-mh-menu-tab]')];
      const panels = [...this.querySelectorAll('[data-mh-menu-panel]')];
      const list = this.querySelector('[data-mh-menu-tabs]');
      if (!list || !tabs.length || tabs.length !== panels.length) return;
      this._bound = true;
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-orientation', 'vertical');
      const resets = panels.map(panel => {
        const visual = panel.querySelector('.mh-mattress-menu__visual');
        if (!visual) return () => {};
        const original = [...visual.children];
        const preview = document.createElement('img');
        preview.className = 'mh-mattress-menu__image';
        preview.style.objectFit = 'contain';
        preview.hidden = true;
        visual.appendChild(preview);
        const restore = () => {
          preview.hidden = true;
          original.forEach(node => { node.hidden = false; });
        };
        preview.addEventListener('error', restore);
        panel.querySelectorAll('[data-mh-preview-link]').forEach(link => {
          const show = () => {
            const src = link.getAttribute('data-mh-preview-src');
            if (!src) { restore(); return; }
            preview.alt = link.getAttribute('data-mh-preview-alt') || '';
            preview.src = src;
            original.forEach(node => { node.hidden = true; });
            preview.hidden = false;
          };
          link.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') show(); });
          link.addEventListener('focus', show);
        });
        return restore;
      });
      const activate = (index, focus = false) => {
        resets.forEach(reset => reset());
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) activate(index);
        });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); event.stopPropagation(); activate(next, true);
        });
      });
      const owner = this.closest('details');
      if (owner) owner.addEventListener('toggle', () => { if (!owner.open) resets.forEach(reset => reset()); });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !owner) return;
        event.preventDefault(); event.stopPropagation(); owner.open = false;
        const summary = owner.querySelector(':scope > summary');
        if (summary) { summary.setAttribute('aria-expanded', 'false'); summary.focus(); }
      });
      activate(0); this.classList.add('is-ready');
    }
  });
})();
